import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from '@reduxjs/toolkit'
import { useHandleLogoutMO } from 'common/hooks/useHandleLogout'

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      console.warn('We have got an unathenticated action!')
      action?.payload?.data?.data === 'Unauthenticated.' &&
        useHandleLogoutMO(api.dispatch)
    }

    return next(action)
  }
